import { memo, useCallback } from 'react';
import { css } from '@linaria/core';
import { classnames } from '@app/common/utils/css';
import { handlePayWithKontempo } from '../utils/kontempo_pay';
import { Cart } from './Cart';
import { SdkDemoContextProvider, useSdkDemoContext } from './Context';
import { Options } from './Options';

export const App = memo(() => {
  return (
    <SdkDemoContextProvider>
      <Layout />
    </SdkDemoContextProvider>
  );
});

const Layout = memo(() => {
  const { options, totalAmount } = useSdkDemoContext();

  const handleSubmit = useCallback(() => {
    if (!options.merchantAccount) {
      alert('Merchant Account is required');
      return;
    }

    if (!options.orderId) {
      alert('Order ID is required');
      return;
    }

    handlePayWithKontempo(options, totalAmount);
  }, [options, totalAmount]);

  return (
    <div className={classnames('app', styles)}>
      <h1>Kontempo - Checkout SDK Demo</h1>

      <div className="docs">
        Documentations:
        <a target="_blank" href="/docs/sdk/sdk_en.html">
          English
        </a>
        <span style={{ opacity: 0.5 }}>|</span>
        <a target="_blank" href="/docs/sdk/sdk_es.html">
          Spanish
        </a>
      </div>

      <div className="content_container">
        <div className="left_content">
          <h2>Cart</h2>
          <Cart onSubmit={handleSubmit} />
        </div>
        <div className="right_content">
          <h2>Checkout Options</h2>
          <Options />
        </div>
      </div>
    </div>
  );
});

const styles = css`
  :global() {
    * {
      margin: 0;
      padding: 0;
      border: none;
      outline: none;
      box-sizing: border-box;
    }

    html,
    body {
      font-family: 'Plus Jakarta Sans';
      font-size: 16px;
      color: #04121f;

      --color-primary: #fb8400;
    }
  }

  padding: 2rem;

  .content_container {
    max-width: 1200px;

    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .left_content,
    .right_content {
      flex: 1;
      margin: 0 5%;
    }

    .left_content {
      margin-left: 0;

      .cart {
        max-width: 500px;
      }
    }

    .right_content {
      margin-right: 0;
    }

    @media (max-width: 767px) {
      flex-direction: column;

      .left_content,
      .right_content {
        margin: 0;
      }

      .right_content {
        margin-top: 5rem;
      }
    }
  }

  h1 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }

  h2 {
    font-size: 1.25rem;
    margin-bottom: 2rem;
  }

  .docs {
    margin-bottom: 3rem;

    font-size: 1rem;
    font-weight: 500;

    a {
      display: inline-block;
      margin: 0.5rem;
      color: #37a78f;
    }
  }
`;
